@if (submitException) {
<div
  class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-color--error fdx-u-mb--5">
  <p class="fdx-u-font-size--small fdx-u-align--center">
    @if (form.invalid) { Formularz zawiera błędy. Popraw je i spróbuj ponownie.
    } @else { Nieoczekiwany błąd systemu. Sprawdź dane i spróbuj ponownie.
    <br />
    Jeśli problem nadal występuje - skontaktuj się z administratorem. }
  </p>
</div>
}
